import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Post } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { EntityCard, EntityCardDefaultProps, EntityCardProps, PostMeta, useComponentPropsFor } from '@shapeable/ui';
const cls = classNames('post-card');

// -------- Types -------->

// -------- Props -------->

export type PostCardProps = Omit<EntityCardProps, 'entity'> & { 
  entity?: Post;
};

export const PostCardDefaultProps: Omit<PostCardProps, 'entity'> = {
  ...EntityCardDefaultProps,
  descriptionMaxLines: 6,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const MetaStyles = breakpoints({
  base: css`
    font-size: 0.8em;
  `,
});



// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    Meta: styled(PostMeta)`${MetaStyles}`,
};

export const PostCard: Shapeable.FC<PostCardProps> = (props) => {
  const { className, children, entity, ...cardProps } = 
  useComponentPropsFor<PostCardProps>('PostCard', PostCardDefaultProps, props);

  return (
    <My.Container
      {...cardProps}
      className={cls.name(className)}
      entity={entity} 
      labelDeriver={() => 'Deep Dive'}
      meta={
        <My.Meta entity={entity} showOrganisationAuthors /> 
      }
    />
  )
};

// PostCard.defaultProps = PostCardDefaultProps;
PostCard.cls = cls;
